import api from './api';
import { 
  CustomerSegment, 
  CustomerSegmentFormData, 
  CustomerSegmentsResponse, 
  CustomerSegmentResponse,
  SegmentReorderRequest 
} from '../types/CustomerSegment';

export const customerSegmentApi = {
  // Get all customer segments
  async getSegments(includeInactive: boolean = false): Promise<CustomerSegmentsResponse> {
    const response = await api.get(`/customer-segments?includeInactive=${includeInactive}`);
    return response.data;
  },

  // Get single customer segment
  async getSegment(id: number): Promise<CustomerSegmentResponse> {
    const response = await api.get(`/customer-segments/${id}`);
    return response.data;
  },

  // Create new customer segment
  async createSegment(data: CustomerSegmentFormData): Promise<CustomerSegmentResponse> {
    const response = await api.post('/customer-segments', data);
    return response.data;
  },

  // Update customer segment
  async updateSegment(id: number, data: Partial<CustomerSegmentFormData>): Promise<CustomerSegmentResponse> {
    const response = await api.put(`/customer-segments/${id}`, data);
    return response.data;
  },

  // Archive customer segment (soft delete)
  async archiveSegment(id: number): Promise<CustomerSegmentResponse> {
    const response = await api.post(`/customer-segments/${id}/archive`);
    return response.data;
  },

  // Restore archived segment
  async restoreSegment(id: number): Promise<CustomerSegmentResponse> {
    const response = await api.post(`/customer-segments/${id}/restore`);
    return response.data;
  },

  // Hard delete customer segment (only if unused)
  async deleteSegment(id: number): Promise<CustomerSegmentResponse> {
    const response = await api.delete(`/customer-segments/${id}`);
    return response.data;
  },

  // Reorder customer segments
  async reorderSegments(orders: SegmentReorderRequest): Promise<CustomerSegmentsResponse> {
    const response = await api.post('/customer-segments/reorder', orders);
    return response.data;
  },

  // Set default segment
  async setDefaultSegment(id: number): Promise<CustomerSegmentResponse> {
    const response = await api.post(`/customer-segments/${id}/set-default`);
    return response.data;
  }
};

export default customerSegmentApi;
